// [BD feat] Cart drawer trust-row drag-scroll — bd-cart-drawer.js
// .bd-cart-drawer__trust-row (sections/cart-drawer.liquid) carries the shared .scroll-area
// utility (theme.css: overflow: auto hidden + scrollbar-width: none) so it can overflow
// locally instead of forcing the whole drawer body to scroll horizontally — see
// assets/bd-cart-drawer.css. That utility only gives native touch-swipe scrolling for free;
// a plain overflow-x: auto element has no click-and-drag support for mouse users, same gap
// the search drawer's "Beliebte Produkte" carousel had (assets/bd-search-drawer.js). This is
// the same plain 1:1 drag-pan, scoped to the trust row instead.
(function () {
  'use strict';

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var rows = scope.querySelectorAll('.bd-cart-drawer__trust-row');
    if (!rows.length) return;

    rows.forEach(function (row) {
      if (row.hasAttribute('data-bd-drag-init')) return;
      row.setAttribute('data-bd-drag-init', '');

      var dragged = false;
      var startX = 0;
      var startScrollLeft = 0;

      function onMouseMove(event) {
        var delta = event.clientX - startX;
        if (Math.abs(delta) > 3) dragged = true;
        row.scrollLeft = startScrollLeft - delta;
      }

      function onMouseUp() {
        row.classList.remove('is-dragging');
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      row.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        dragged = false;
        startX = event.clientX;
        startScrollLeft = row.scrollLeft;
        row.classList.add('is-dragging');
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      // A drag that moved the cursor shouldn't also fire a click on whatever's underneath.
      row.addEventListener('click', function (event) {
        if (dragged) {
          event.preventDefault();
          dragged = false;
        }
      }, true);
    });
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (!event.target.querySelector('.bd-cart-drawer__trust-row')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Cart drawer trust-row drag-scroll
